(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hz-tabbed-new-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hz-product-tabs')) {
    class HzProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') {
          return;
        }

        this.dataset.initialized = 'true';

        const tabs = Array.from(
          this.querySelectorAll('[role="tab"][data-tab]')
        );

        const panels = Array.from(
          this.querySelectorAll('[role="tabpanel"][data-panel]')
        );

        if (!tabs.length) {
          return;
        }

        /*
         * A rejtett tabok képeit is előkészítjük.
         * Ez Safari alatt megakadályozza, hogy tabváltáskor
         * üres maradjon egy termékkép.
         */
        panels.forEach((panel) => {
          panel.querySelectorAll('img').forEach((image) => {
            if (image.loading === 'lazy') {
              image.loading = 'eager';
              image.setAttribute('loading', 'eager');
            }

            image.decoding = 'async';
          });
        });

        const prepareActivePanel = (activePanel) => {
          if (!activePanel) {
            return;
          }

          const images = Array.from(
            activePanel.querySelectorAll('img')
          );

          const slides = Array.from(
            activePanel.querySelectorAll(
              'slideshow-slide, .card-gallery, .product-card'
            )
          );

          slides.forEach((element) => {
            element.style.contentVisibility = 'visible';
          });

          images.forEach((image) => {
            image.loading = 'eager';
            image.setAttribute('loading', 'eager');
            image.style.contentVisibility = 'visible';
            image.style.backfaceVisibility = 'hidden';
            image.style.transform = 'translateZ(0)';

            if (
              image.complete &&
              typeof image.decode === 'function'
            ) {
              image.decode().catch(() => {});
            }
          });

          /*
           * Kényszerített layout-újraszámítás.
           */
          void activePanel.offsetHeight;

          /*
           * Az első ciklusban a böngésző érzékeli, hogy
           * a panel láthatóvá vált. A másodikban újrarajzolja
           * a képeket és újraszámolja a galériákat.
           */
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              activePanel.classList.add('is-rendered');

              window.dispatchEvent(
                new Event('resize')
              );

              images.forEach((image) => {
                image.style.transform = 'translateZ(0.001px)';

                requestAnimationFrame(() => {
                  image.style.transform = 'translateZ(0)';
                });
              });
            });
          });
        };

        const activateTab = (
          selectedTab,
          moveFocus = false
        ) => {
          const selectedName = selectedTab.dataset.tab;
          let activePanel = null;

          tabs.forEach((tab) => {
            const isActive = tab === selectedTab;

            tab.classList.toggle(
              'is-active',
              isActive
            );

            tab.setAttribute(
              'aria-selected',
              isActive ? 'true' : 'false'
            );

            tab.setAttribute(
              'tabindex',
              isActive ? '0' : '-1'
            );
          });

          panels.forEach((panel) => {
            const isActive =
              panel.dataset.panel === selectedName;

            panel.hidden = !isActive;

            panel.setAttribute(
              'aria-hidden',
              isActive ? 'false' : 'true'
            );

            panel.classList.toggle(
              'is-active',
              isActive
            );

            if (isActive) {
              activePanel = panel;
            }
          });

          if (moveFocus) {
            selectedTab.focus();
          }

          prepareActivePanel(activePanel);
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            activateTab(tab);
          });

          tab.addEventListener(
            'keydown',
            (event) => {
              if (
                ![
                  'ArrowLeft',
                  'ArrowRight',
                  'Home',
                  'End'
                ].includes(event.key)
              ) {
                return;
              }

              event.preventDefault();

              let nextIndex = index;

              if (event.key === 'ArrowRight') {
                nextIndex =
                  (index + 1) % tabs.length;
              }

              if (event.key === 'ArrowLeft') {
                nextIndex =
                  (
                    index -
                    1 +
                    tabs.length
                  ) % tabs.length;
              }

              if (event.key === 'Home') {
                nextIndex = 0;
              }

              if (event.key === 'End') {
                nextIndex =
                  tabs.length - 1;
              }

              activateTab(
                tabs[nextIndex],
                true
              );
            }
          );
        });

        const initialTab =
          tabs.find(
            (tab) =>
              tab.getAttribute(
                'aria-selected'
              ) === 'true'
          ) || tabs[0];

        activateTab(initialTab);
      }
    }

    customElements.define(
      'hz-product-tabs',
      HzProductTabs
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
